import React from "react";
import { useAuth } from "../../providers/AuthProvider";
import AdminDashboard from "./AdminDashboard";
import CandidateDashboard from "./CandidateDashboard";
import MainLayout from "../../layouts/MainLayout";

const Home = () => {
  const keycloak = useAuth();
  const isAdmin = keycloak?.hasRealmRole?.("admin") ?? false;

  return (
    <MainLayout>
      {isAdmin ? <AdminDashboard /> : <CandidateDashboard />}
    </MainLayout>
  );
};

export default Home;
